/* ck-wishlist — Phase-1 native wishlist store (localStorage, no app).
   Single source of truth for the saved-products list + the header count badge.
   Loaded globally from layout/theme.liquid so the header count works on every page.

   Storage: localStorage key "ss_wishlist" = array of { handle, id } (deduped by handle).
   Public API on window.SSWishlist: read(), has(handle), add(item), remove(handle),
   toggle(item) -> bool (now-active?), count().
   Fires document event "ss:wishlist:change" {detail:{count}} on every mutation and on a
   cross-tab storage change, so cards + the wishlist page can re-sync. Phase-2 (cross-device
   sync, back-in-stock / price-drop emails) is the paid Swym app — intentionally NOT here. */

(function () {
  'use strict';

  var KEY = 'ss_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(arr)) return [];
      var seen = {}, out = [];
      arr.forEach(function (it) {
        if (!it || !it.handle) return;
        var h = String(it.handle);
        if (seen[h]) return;
        seen[h] = 1;
        out.push({ handle: h, id: it.id ? String(it.id) : '' });
      });
      return out;
    } catch (e) { return []; }
  }

  function persist(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
    emit(false);
  }

  function has(handle) {
    if (!handle) return false;
    handle = String(handle);
    return read().some(function (it) { return it.handle === handle; });
  }

  function add(item) {
    if (!item || !item.handle) return read();
    var arr = read();
    var h = String(item.handle);
    if (!arr.some(function (it) { return it.handle === h; })) {
      arr.push({ handle: h, id: item.id ? String(item.id) : '' });
      persist(arr);
    }
    return arr;
  }

  function remove(handle) {
    if (!handle) return read();
    handle = String(handle);
    var arr = read().filter(function (it) { return it.handle !== handle; });
    persist(arr);
    return arr;
  }

  function toggle(item) {
    if (!item || !item.handle) return false;
    if (has(item.handle)) { remove(item.handle); return false; }
    add(item);
    return true;
  }

  function count() { return read().length; }

  function emit(external) {
    syncBadge();
    try {
      document.dispatchEvent(new CustomEvent('ss:wishlist:change', {
        detail: { count: count(), external: !!external }
      }));
    } catch (e) {}
  }

  /* Live header count badge(s). Hidden/zeroed when empty. */
  function syncBadge() {
    var n = count();
    var nodes = document.querySelectorAll('[data-ck-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); el.classList.add('is-visible'); }
      else { el.setAttribute('hidden', ''); el.classList.remove('is-visible'); }
    }
  }

  window.SSWishlist = {
    read: read, has: has, add: add, remove: remove,
    toggle: toggle, count: count, KEY: KEY
  };

  function boot() { syncBadge(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Cross-tab sync: another tab changed the list. */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    emit(true);
  });
})();
